import React, { FC } from 'react';
import { HashRouter } from "react-router-dom";
import { Provider } from "react-redux";
import './styles/_default.scss';
import './styles/_font.scss';
import '@infobis/ui-styles-utils/styles';
import { store } from "./store";
import { LicenseManager } from "ag-grid-enterprise";
import ProvideMutableStore from "@context/map/mutableStore";
import KeepAlive from 'react-fiber-keep-alive';
import { CustomRoutes, DashboardRoutes, PartnersRoutes } from "./routes";
import { AsMicroserviceBoot, MicroserviceId } from "@infobis/microservice-bridge"
import { AuthActions } from "@infobis/as-react-auth";
import { actions as AppSettingsActions } from "./store/reducers/settings";
import LoadingBox from "@elements/loading/LoadingBox";
import ReactDOM from "react-dom";
import { ApiContext, TApiContext } from "@context/ApiContext";

LicenseManager.setLicenseKey("Infobis_Agrosignal_2Devs1_SaaS_15_December_2018__MTU0NDgzMjAwMDAwMA==118e677125ef467d485b18ea9abd8c0e");
export const root = document.getElementById('root')!;

const App = (Routes: FC<any>, api?: TApiContext) => {

    return ReactDOM.render(
        <HashRouter>
            <Provider store={store}>
                <ProvideMutableStore>
                    <KeepAlive.Provider value={root}>
                        <ApiContext.Provider value={api}>
                            <Routes/>
                        </ApiContext.Provider>
                    </KeepAlive.Provider>
                </ProvideMutableStore>
            </Provider>
        </HashRouter>, root)
};

ReactDOM.render(<LoadingBox/>, root)

const onBootMicroCb = (routes: () => JSX.Element) => (api: TApiContext) => {
    store.dispatch(AppSettingsActions.toggleMainMenuVisibility({ visible: false }))
    api.onAuthenticationRefresh(async (accessToken) => {
        await store.dispatch(AuthActions.setAccessToken(accessToken))
    })
    api.onAuthenticationReady(async (authentication) => {
        await store.dispatch(AuthActions.authenticateAction(authentication))
        App(routes, api)
    })
}

const AsMicroserviceDash = () => (
     AsMicroserviceBoot(MicroserviceId.DASHBOARD, {
        callApi: {
            async refresh() {
                store.dispatch(AppSettingsActions.triggerRefresh())
            }
        },
        getApi: {},
    }).onBoot(onBootMicroCb(DashboardRoutes))
);

const AsMicroservicePartners = () => (
    AsMicroserviceBoot(MicroserviceId.PARTNERS, {
        callApi: {
            async refresh() {
                store.dispatch(AppSettingsActions.triggerRefresh())
            },
        },
        getApi: {},
    }).onBoot(onBootMicroCb(PartnersRoutes))
);

AsMicroserviceDash().orElse(() => AsMicroservicePartners().orElse(() => App(CustomRoutes)));